import React, { useEffect, useRef } from 'react';
import './App.css';
import useYogaPresenter from './presenters/useYogaPresenter';
import LoadingView from './views/LoadingView';
import MainPageView from './views/MainPageView';
import OptionsView from './views/OptionsView';
import SequencePageView from './views/SequencePageView';

function App() {
  const presenter = useYogaPresenter();
  const hasDisplayedMainPage = useRef(false);
  const animateMainPage = !presenter.isLoading && !hasDisplayedMainPage.current;

  useEffect(() => {
    if (animateMainPage) {
      hasDisplayedMainPage.current = true;
    }
  }, [animateMainPage]);

  if (presenter.isLoading) {
    return <LoadingView />;
  }

  const renderHeaderOptions = () => (
    <OptionsView
      animating={presenter.animating}
      closeOptions={presenter.closeOptions}
      isOpen={presenter.isOptionsOpen}
      options={presenter.options}
      selected={presenter.selected}
      selectOption={presenter.selectOption}
      toggleOptions={presenter.toggleOptions}
    />
  );

  if (presenter.activeSequence) {
    return (
      <SequencePageView
        activeSequence={presenter.activeSequence}
        imageSources={presenter.imageSources}
        selected={presenter.selected}
        renderHeaderOptions={renderHeaderOptions}
        onGoHome={presenter.showHome}
        onStartSequence={presenter.openSequence}
      />
    );
  }

  return (
    <MainPageView
      animateEntry={animateMainPage}
      imageSources={presenter.imageSources}
      renderHeaderOptions={renderHeaderOptions}
      onStartSequence={presenter.openSequence}
    />
  );
}

export default App;
